import axios, { AxiosPromise } from 'axios';

import { Provider } from '../type';
import KeycloakService from './KeycloakService';

export const getAvailableProviders = (): AxiosPromise<Provider[]> =>
  axios.get(`${KeycloakService.getUrl()}/providers`, {
    headers: {
      Authorization: `Bearer ${KeycloakService.getToken()}`
    }
  });

export const getProviderAccountLink = (
  provider: string
): AxiosPromise<string> =>
  axios.get(`${KeycloakService.getUrl()}/providers/link`, {
    params: {
      provider,
      'redirect-uri': window.location.href
    },
    headers: {
      Authorization: 'Bearer ' + KeycloakService.getToken()
    }
  });
